<script setup lang="ts">
// Components of Module
import { Polygon as GooglePolygon } from 'vue3-google-map'

// Types
import { AreaProperties } from '@/api/modules/delivery/types'
import {
  TypesEntity,
  IGoogleCoords,
  GoogleClickEvent,
} from '@/types/mapServices'

const props = defineProps({
  areas: {
    type: Array as PropType<AreaProperties[]>,
    required: false,
    default: () => [],
  },
})

const emits = defineEmits(['clickedToMapOfElement'])

// Генерация объекта для полигона
const transformCoords = (area: AreaProperties) => {
  return area.polygon[0].map((coordinate) => ({
    lat: coordinate[0],
    lng: coordinate[1],
  }))
}

const generateOptionPolygon = (area: AreaProperties) => {
  return {
    strokeOpacity: 0,
    fillOpacity: 0.3,
    fillColor: area.properties.stroke,
    strokeColor: area.properties.stroke,
    paths: [...transformCoords(area)],
  }
}

const clickedPolygon = (event: GoogleClickEvent) => {
  const clickedCoords: IGoogleCoords = {
    lat: event.latLng.lat(),
    lng: event.latLng.lng(),
  }

  emits('clickedToMapOfElement', {
    type: TypesEntity.FEATURE,
    coords: clickedCoords,
  })
}
</script>

<template>
  <google-polygon
    v-for="area in props.areas"
    :key="area.id"
    :options="generateOptionPolygon(area)"
    @click="clickedPolygon"
  />
</template>
